module.exports = __webpack_public_path__ + "static/media/gplaypattern.5dacd004.png";